import { BookOpen, Target, Award } from "lucide-react";

export default function EducatorOverlay({ module }) {
  if (!module) return null;
  
  const standards = module.standards || {};

  return (
    <div className="bg-indigo-50 border border-indigo-200 rounded-xl p-5 mb-6 space-y-4" data-testid="educator-overlay">
      {/* Learning Objective */}
      {module.learning_objective && (
        <div className="flex gap-3">
          <BookOpen className="w-5 h-5 text-indigo-500 shrink-0 mt-0.5" />
          <div>
            <h4 className="text-sm font-semibold text-indigo-800 mb-1">Learning Objective</h4>
            <p className="text-sm text-indigo-700">{module.learning_objective}</p>
          </div>
        </div>
      )}

      {/* Standards Alignment */}
      {Object.keys(standards).length > 0 && (
        <div className="flex gap-3">
          <Target className="w-5 h-5 text-indigo-500 shrink-0 mt-0.5" />
          <div>
            <h4 className="text-sm font-semibold text-indigo-800 mb-2">Standards Alignment</h4>
            <div className="space-y-1.5">
              {standards.nevada_cte && (
                <div className="text-xs"><span className="font-medium text-indigo-800">Nevada CTE:</span> <span className="text-indigo-600">{standards.nevada_cte}</span></div>
              )}
              {standards.employability && (
                <div className="text-xs"><span className="font-medium text-indigo-800">Employability Skills:</span> <span className="text-indigo-600">{standards.employability}</span></div>
              )}
              {standards.workforce_readiness && (
                <div className="text-xs"><span className="font-medium text-indigo-800">Workforce Readiness:</span> <span className="text-indigo-600">{standards.workforce_readiness}</span></div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Lesson Outcome */}
      {module.outcome && (
        <div className="flex gap-3">
          <Award className="w-5 h-5 text-indigo-500 shrink-0 mt-0.5" />
          <div>
            <h4 className="text-sm font-semibold text-indigo-800 mb-1">Lesson Outcome</h4>
            <p className="text-sm text-indigo-700">{module.outcome}</p>
          </div>
        </div>
      )}
    </div>
  );
}
